import { Timestamp } from 'api/models';

export interface CalendarEventsParam {
  calendarId: string;
  integrationId: number;
  startDate: Timestamp;
  endDate: Timestamp;
}

export const calendarUrl = (integrationId: number): string =>
  `/integrations/${integrationId}/calendars`;

export const eventsUrl = ({
  integrationId,
  calendarId,
  startDate,
  endDate,
}: CalendarEventsParam): string => {
  const calendarIdWithoutHash = calendarId.replaceAll('#', '%23');

  return `${calendarUrl(
    integrationId,
  )}/${calendarIdWithoutHash}/events?startDate=${startDate}&endDate=${endDate}&autoSuggest=${true}`;
};
